<template>
    <v-sheet>
        <v-fade-transition>
            <v-overlay v-show="!company" color="white" absolute>
                <v-progress-circular indeterminate width="5" size="100" color="primary" />
            </v-overlay>
        </v-fade-transition>

        <company-view-heading v-bind="{ company }">
            <template #actions>
                <like-btn :params="likeParams">
                    <template #activator="{ active, toggle }">
                        <v-btn icon text outlined :color="active ? 'yellow darken-1' : 'grey-c'" class="like-btn" @click="toggle">
                            <v-icon :color="active ? undefined : 'grey-9'">{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                        </v-btn>
                    </template>
                </like-btn>
                <!-- <like-btn :params="likeParams">
                    <template #activator="{ active, toggle }">
                        <v-sheet outlined rounded="lg" :color="active ? 'yellow darken-1' : 'transparent'" @click="toggle">
                            <v-btn outlined large icon text class="pa-20">
                                <v-icon :color="active ? 'white' : undefined">{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                            </v-btn>
                        </v-sheet>
                    </template>
                </like-btn> -->
            </template>
        </company-view-heading>

        <v-divider class="border-2 primary my-16 my-lg-20" />

        <div class="page-section">
            <h5 class="page-text page-text--lg mb-8 mb-lg-16">채용중인 공고</h5>
            <company-view-recruitments v-if="company" :params="recruitmentsParams" />
        </div>

        <div class="page-section">
            <h5 class="page-text page-text--lg mb-8 mb-lg-16">기업/서비스 소개</h5>
            <company-view-introduction-images v-if="company" v-bind="company?.introduction" multiple class="mb-16 mb-lg-20" />
            <company-view-introduction-content v-bind="company?.introduction" expanded />
        </div>

        <h5 class="page-text page-text--lg mb-8 mb-lg-16">주소</h5>
        <p class="page-text line-height-15">{{ address }}</p>
        <v-responsive :aspect-ratio="16 / 9" class="mt-12 mt-lg-16">
            <company-view-location-map v-bind="{ company }" />
        </v-responsive>
    </v-sheet>
</template>

<script>
import { RECRUITMENT_STATES, USER_LIKE_TYPES } from "@/assets/variables";

import LikeBtn from "@/components/client/like/like-btn.vue";
import CompanyViewHeading from "./company-view-heading.vue";
import CompanyViewLocationMap from "./company-view-location-map.vue";
import CompanyViewRecruitments from "./company-view-recruitments.vue";
import CompanyViewIntroductionImages from "./company-view-introduction-images.vue";
import CompanyViewIntroductionContent from "./company-view-introduction-content.vue";

export default {
    components: {
        LikeBtn,
        CompanyViewHeading,
        CompanyViewLocationMap,
        CompanyViewRecruitments,
        CompanyViewIntroductionImages,
        CompanyViewIntroductionContent,
    },
    props: {
        company: { type: Object },
    },
    computed: {
        address() {
            let address = [];
            const { address1, address2 } = this.company || {};
            address += [address1, address2].filter((item) => item).join(", ");

            return address;
        },
        likeParams() {
            return {
                _userCompany: this.company?._id,
                type: USER_LIKE_TYPES.USER_COMPNY.value,
            };
        },
        recruitmentsParams() {
            return {
                _company: this.company?._id,
                state: RECRUITMENT_STATES.ON_GOING.value,
                "application.endsAt": [ null, { $gte: Date.now() }]
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.like-btn {
    width: 44px;
    height: 44px;
    border-radius: 6px;
    .v-icon {
        font-size: 20px;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .like-btn {
        width: 56px;
        height: 56px;
        .v-icon {
            font-size: 26px;
        }
    }
}
@media (min-width: 1200px) {
}
</style>